/* eslint-disable @typescript-eslint/no-explicit-any */
import Card from 'components/card/Card'
import { DatePicker, Input, Select, Tag, Typography } from 'antd'
import { Mill } from 'generated/api'
import { ExtendedCampaignsProgram } from '../hooks/useCampaignCreation'
import { FormikErrors, FormikTouched } from 'formik'
import dayjs from 'dayjs'
import { regexAlphaNumericSpacesCommaDot } from 'constants/regex'

export interface IProps {
  millData: Mill[]
  data: ExtendedCampaignsProgram
  onChange: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined,
  ) => Promise<void> | Promise<FormikErrors<ExtendedCampaignsProgram>>
  errors: FormikErrors<ExtendedCampaignsProgram>
  touched: FormikTouched<ExtendedCampaignsProgram>
  isLoading: boolean
}

const CampaignProgram = (props: IProps) => {
  const { RangePicker } = DatePicker

  const { millData, data, onChange, isLoading } = props

  const filterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

  const millName = millData?.filter(mill => mill.id == data.partnerId)[0]?.name

  return (
    <Card className="h-fit !p-0" loading={false} dataTestId="card_TBS" spinnerTestId="loader_TBS">
      <Card.Header className="py-6" border={false}>
        <Typography.Text className="px-8 border-l-4 border-y-0 border-r-0 border-solid border-primary-600 text-xl font-bold">
          1. Informasi Program
        </Typography.Text>
      </Card.Header>
      <Card.Body className="m-0 pb-8 px-8">
        <div className="flex gap-4">
          <div className="flex-1 flex-col">
            <Typography.Text
              className="block text-xs font-bold leading-5 text-[#323539] mb-2"
              data-testid="mills_name"
            >
              Nama Pabrik
            </Typography.Text>
            <Select
              showSearch
              disabled={isLoading}
              className="w-[336px] h-[40px]"
              data-testid="input_mills"
              onChange={value => onChange('partnerId', value)}
              optionFilterProp="children"
              filterOption={filterOption}
              value={{
                label: data.partnerId !== '' ? millName : 'Pilih Pabrik',
                value: '',
              }}
              placeholder="Pilih Pabrik"
              options={millData.map(item => {
                return {
                  value: item.id,
                  label: item.name,
                }
              })}
            />
          </div>
          <div className="flex-1 flex-col">
            <Typography.Text className="block text-xs font-bold leading-5 text-[#323539] mb-2">
              Jenis Program
            </Typography.Text>
            <div className="flex gap-2 h-full">
              <Tag.CheckableTag
                data-testid="type-version-1"
                className="h-[42px] flex-1 flex m-0 items-center justify-center text-sm cursor-pointer"
                checked={data.version == 1}
                onChange={() => onChange('version', 1)}
              >
                Panen Emas v.1.0
              </Tag.CheckableTag>
              <Tag.CheckableTag
                data-testid="type-version-2"
                className="h-[42px] flex-1 flex m-0 items-center justify-center text-sm cursor-pointer"
                checked={data.version == 2}
                onChange={() => onChange('version', 2)}
              >
                Panen Emas v.2.0
              </Tag.CheckableTag>
            </div>
          </div>
          <div className="flex-1 flex-col">
            <Typography.Text
              className="block text-xs font-bold leading-5 text-[#323539] mb-2"
              data-testid="date_send"
            >
              Tanggal Program
            </Typography.Text>

            <div className="flex-1 items-center flex gap-1 flex-col">
              <RangePicker
                placeholder={['Tanggal Mulai', 'Tanggal Berakhir']}
                data-testid="delivery-date-only"
                className="w-full px-4 py-2 rounded-lg"
                allowClear={false}
                showTime={{
                  format: 'HH:mm',
                }}
                changeOnScroll
                format="DD MMM YYYY, HH:mm"
                value={
                  data.startTime || data.endTime
                    ? [dayjs(data.startTime), dayjs(data.endTime)]
                    : null
                }
                onChange={value => {
                  const startValue = dayjs(value?.[0]).valueOf()
                  const endValue = dayjs(value?.[1]).valueOf()
                  onChange('startTime', startValue)
                  onChange('endTime', endValue)
                  onChange('participantsExtend', [])
                }}
              />
            </div>
          </div>
        </div>
        <div className="flex gap-4 mt-4">
          <div className="flex flex-1 flex-col">
            <Typography.Text className="block text-xs font-bold leading-5 text-[#323539] mb-2">
              Nama Program
            </Typography.Text>
            <Input
              data-testid="program-name"
              disabled={false}
              className="px-4 py-2 rounded-lg"
              placeholder="Masukkan nama program"
              value={data.name}
              onChange={e => {
                const val = e.currentTarget.value
                if (!val.startsWith(' ') && regexAlphaNumericSpacesCommaDot.test(val)) {
                  onChange('name', val)
                }
              }}
            />
          </div>
        </div>
      </Card.Body>
    </Card>
  )
}

export default CampaignProgram
